import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { Base_Url } from '../BaseUrl'
import Sidebaar from '../Component/Sidebar'
import { Box, ClickAwayListener, MenuItem, MenuList, Paper, Popper } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid'
import TitleComp from '../Component/TitleComp'
import { Button } from 'react-bootstrap'
import { toast } from 'react-toastify'
import { Bars } from 'react-loader-spinner'

function Camplain() {
    const [data, setdata] = useState([])
    let token = localStorage.getItem("token")
    const [loading, setloading] = useState(false)
    const [search, setsearch] = useState("")

    const headers = {
        Authorization: `Bearer ${token}`
    }
    const handleget = () => {
        axios.get(`${Base_Url}/complain`, { headers }).then((res) => {
            console.log(res)
            setdata(res.data.data)
        })
    }

    useEffect(() => {
        if (search.length == "0") {
            handleget()
        }
    }, [search])

    const handlechangestatus = (e, name, id) => {
        e.preventDefault()
        setloading(true)
        let requestdata = {
            _id: id,
            status: name
        }
        axios.put(`${Base_Url}/complain`, requestdata, { headers }).then((res) => {
            console.log(res)
            if (res.data.error == 0) {
                toast.success("Data Submitted Successfully")
                handleget()
            }
        }).finally(() => {
            setloading(false)
        })
    }

    const getRowId = (row) => row._id

    const handlefilter = (e) => {
        e.preventDefault();

        let res = data.filter((item) =>
            item.user?.name.toLowerCase()?.includes(search.toLowerCase())

        );

        setdata(res)




    };
    return (
        <>
            {loading && (
                <div className="overlay">
                    <Bars
                        height="80"
                        width="80"
                        color="#051322"
                        ariaLabel="bars-loading"
                        visible={true}
                    />
                </div>
            )}
            <Sidebaar content={
                <>
                    <div className="col-md-12">
                        <div className="mb-3">
                            <TitleComp title="Complain List" />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <form class="" onSubmit={(e) => handlefilter(e)}>
                            <div class="input-group mt-4">
                                <input type="search" placeholder="Search By Username" value={search} onChange={(e) => setsearch(e.target.value)} class="form-control shadow-none" />
                                <button class="btn bg-primary text-white"><i class="fa-solid fa-magnifying-glass"></i></button>
                            </div>
                        </form>
                    </div>
                    <div className="col-md-12">
                        {/* <Box sx={{ height: 500, width: "100%" }}>
                            <DataGrid
                                rows={data}
                                columns={columns}
                                pageSize={5}
                                getRowId={getRowId}
                                initialState={{
                                    pagination: { paginationModel: { pageSize: 10 } },
                                }}
                                pageSizeOptions={[5, 10, 25]}
                            />
                        </Box> */}
                        <div className="w-100">
                            <table className='table '>
                                <thead >
                                    <tr>
                                        <th>
                                            User Name
                                        </th>
                                        <th>
                                            Subject
                                        </th>
                                        <th>
                                            Message
                                        </th>
                                        <th>
                                            Status
                                        </th>
                                        <th>
                                            Action
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.map((item) => {
                                        return (
                                            <>
                                                <tr>
                                                    <td>{item.user.name}</td>
                                                    <td>{item.subject}</td>
                                                    <td>{item.message}</td>
                                                    <td><span style={{ letterSpacing: "2px" }} className={`badge ${item.status == "Pending" ? "bg-warning" : item.status == "Processing" ? "bg-primary" : "bg-success"}`}>{item.status}</span></td>
                                                    <td>
                                                        {item.status != "Solved" ? <div className="dropdown">
                                                            <button style={{ fontSize: "14px" }} className="btn bg-dark text-white" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                                                                Change Status
                                                            </button>
                                                            <ul className="dropdown-menu custom-dropdown" aria-labelledby="dropdownMenuButton1">
                                                                {item.status != "Processing" && <li><button className="dropdown-item" onClick={(e) => handlechangestatus(e, "Processing", item._id)}>Processing</button></li>}
                                                                <li><button className="dropdown-item" onClick={(e) => handlechangestatus(e, "Solved", item._id)}>Solved</button></li>
                                                            </ul>
                                                        </div> : ""}
                                                    </td>
                                                </tr>
                                            </>
                                        )
                                    })}

                                </tbody>
                            </table>
                        </div>
                    </div>


                </>
            } />
        </>
    )
}

export default Camplain
